import { useEffect, useState } from 'react';
import 'whatwg-fetch';
import 'devextreme/data/odata/store';
import { Series, Label, Connector, Legend, Export, Font, Tooltip } from 'devextreme-react/chart';
import reportService from '@/projects/platform/services/report-service';
import { LoadIndicator, PieChart } from 'devextreme-react';
import { Format } from 'devextreme-react/data-grid';

export default function SalesAmountByProductGroup(props: any) {
    var params: string;
    const { retailerId, startDate, endDate } = props;
    const [dataSource, setDataSource] = useState([]);
    const [loading, setLoading] = useState(true);

    function filter() {
        params = '';
        for (const key of Object.keys(props)) {
            if (props[key]) {
                params += `${key}=${props[key]}&`;
            }
        }
        params = params.slice(0, -1);
    }

    useEffect(() => {
        setLoading(true);
        filter();
        reportService.getSalesAmountByProductGroup(params)
            .then((response) => {
                setDataSource(response.data.searchResult);
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
                throw new Error('Data Loading Error');
            });
    }, [retailerId, startDate, endDate]);

    function customizeText(arg: any) {
        return `${formatCurrency(arg.valueText)} (${arg.percentText})`;
    }
    function formatCurrency(amount: number): string {
        return new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' }).format(amount);
    }

    function customizeTooltip(arg: any) {
        return {
            text: `${arg.valueText}`
        };
    }
    return (
        <>
            <LoadIndicator visible={loading} />
            <PieChart id="pie"
                palette="Bright"
                dataSource={dataSource}
                title="Sales Amount By Product Group"
            >
                <Legend
                    orientation="horizontal"
                    itemTextPosition="right"
                    horizontalAlignment="center"
                    verticalAlignment="bottom"
                    columnCount={4} />
                <Export enabled={true} />
                <Series argumentField="productGroup" valueField="salesAmount">
                    <Label
                        visible={true}
                        customizeText={customizeText}>
                        <Font size={16} />
                        <Connector visible={true} />
                    </Label>
                </Series>
                <Tooltip enabled={true} customizeTooltip={customizeTooltip}>
                    <Format type="largeNumber" />
                </Tooltip>
            </PieChart>
        </>
    );
}
